import React from "react";
import { Platform, View } from "react-native";
import {
  Alert,
  VStack,
  Heading,
  Box,
  HStack,
  IconButton,
  CloseIcon,
} from "native-base";
import CountDown from "../components/CountDown";
import { translate } from "../locales/translate";
import Theme from "../argon-ui/Theme";
import { getDir } from "../util";

const IS_WEB = Platform.OS == "web";
const IS_WEB_DIRECTION = IS_WEB ? "row-reverse" : "row";

const ToastAlert = ({
  id,
  status = "info",
  variant,
  title,
  description,
  isClosable,
  // closHandler,
  countDown,
  closeToastHandler,
  closePosition = "top",
  ...rest
}: any) => {
  isClosable = isClosable;
  const renderClosePosition = () => {
    return (
      <IconButton
        onPress={() => {
          typeof closeToastHandler === "function" && closeToastHandler();
          // typeof closHandler === "function" && closHandler;
        }}
        variant="unstyled"
        icon={<CloseIcon size="3" color="coolGray.600" />}
      />
    );
  };
  return (
    <Alert
      shadow={2}
      maxW="400"
      w="100%"
      rounded="2xl"
      status={status}
      variant={variant}
      {...rest}
    >
      <VStack space={1} flexShrink={1} w="100%">
        <HStack
          flexShrink={1}
          space={2}
          alignItems="flex-start"
          justifyContent="space-between"
          flexDirection={IS_WEB_DIRECTION}
        >
          <HStack
            space={2}
            flexShrink={1}
            alignItems="flex-start"
            flexDirection={IS_WEB_DIRECTION}
          >
            <Alert.Icon size="md" />
            <Heading
              fontSize="xs"
              fontWeight="medium"
              color="coolGray.800"
              lineHeight="2xl"
              flexShrink={1}
            >
              {title}
            </Heading>
          </HStack>
          {isClosable && closePosition == "top" && renderClosePosition()}
        </HStack>
        {description && (
          <Box
            m="2"
            _text={{
              // textAlign: "center",
              color: "coolGray.600",
              fontSize: "12px",
            }}
          >
            {description}
          </Box>
        )}
        {Number(countDown) > 0 && (
          <View style={{ margin: 10, direction: getDir() }}>
            <CountDown
              until={Number(countDown)}
              size={12}
              digitStyle={{ color: "#FFFFFF00" }}
              digitTxtStyle={{ color: Theme.COLORS.BLACK }}
              timeLabelStyle={{ color: Theme.COLORS.GRAY_DARK }}
              timeLabels={{
                d: translate("timer.days"),
                h: translate("timer.hours"),
                m: translate("timer.minutes"),
                s: translate("timer.seconds"),
              }}
              showSeparator
            />
          </View>
        )}
        {/* {isClosable && closePosition == "down" && (
          <IconButton
            onPress={closHandler}
            variant="unstyled"
            style={{ alignSelf: IS_WEB ? "flex-start" : "flex-end" }}
            icon={<CloseIcon size="3" color="coolGray.600" />}
          />
        )} */}
      </VStack>
    </Alert>
  );
};

export default ToastAlert;
